import axios from 'axios'
import ApplicationController from './application_controller.js'
export default class AutoMailsController extends ApplicationController {

  static targets = ['frequency', 'roles']

  // Click sur checkbox pour activer ou désactiver un automailer
  change_mailer_state(e) {
    var state = e.target.checked
    this.frequencyTarget.disabled = !state
    this.rolesTarget.disabled = !state
  }

  preview(e) {
    e.preventDefault()
    var form = e.target.closest('form')
    var form_data = new FormData(form)
    form_data.append('frequency', this.frequencyTarget.value)
    axios.post(`${e.target.href}&frequency=${this.frequencyTarget.value}`).then(response => {
      this.modal(response.data, { size: 'large' }, (reason) => {
        reason.close_modal()
        if (reason.confirm) {
          axios.post(reason.form.getAttribute('action'), new FormData(reason.form)).then(response => {
            this.modal(response.data, { size: 'large' }, (reason) => {
              reason.close_modal()
            })
          })
        }
      })
    })
  }

}